/**
 * Aseli Product Details — details accordion (Zutaten/Nährwerte/Hinweise).
 * Extracted from section-aseli-main-product.js. Idempotent (guards) + shopify:section:load support.
 */
(function () {
  function initSection(root) {
    root.querySelectorAll('[data-apd-acc-toggle]').forEach(function (btn) {
      if (btn.getAttribute('data-apd-bound')) return;
      btn.setAttribute('data-apd-bound', '1');
      var item = btn.closest('.apd__acc-item');
      // First item opens by default (aria-expanded="true" in markup); sync .is-open from it.
      if (btn.getAttribute('aria-expanded') === 'true' && item) item.classList.add('is-open');
      btn.addEventListener('click', function () {
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.apd').forEach(initSection);
  }
  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      initSection(event.target);
    }
  });
})();
